/**
 * js/faq.js — Ghonché Frequently Asked Questions Interactive Logic
 * Handles category jump-links, active category pill tracking via IntersectionObserver,
 * and URL hash handling with zero console errors.
 */

(function () {
  'use strict';

  function initFaq() {
    const navPills = document.querySelectorAll('.faq-nav__pill');
    const groups = document.querySelectorAll('.faq-group');

    if (!groups.length) return;

    // 1. IntersectionObserver to update active quick-nav pill on scroll
    if ('IntersectionObserver' in window && navPills.length > 0) {
      const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0
      };

      const groupObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            navPills.forEach((pill) => {
              const href = pill.getAttribute('href');
              if (href === '#' + id) {
                pill.classList.add('is-active');
                pill.setAttribute('aria-current', 'true');
              } else {
                pill.classList.remove('is-active');
                pill.removeAttribute('aria-current');
              }
            });
          }
        });
      }, observerOptions);

      groups.forEach((group) => groupObserver.observe(group));
    }

    // 2. Handle URL hash on initial load
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const targetEl = document.getElementById(hash);
      if (targetEl) {
        if (targetEl.tagName.toLowerCase() === 'details') {
          targetEl.open = true;
        } else {
          const firstDetails = targetEl.querySelector('details');
          if (firstDetails) {
            firstDetails.open = true;
          }
        }
        setTimeout(() => {
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();
